module.exports = __webpack_public_path__ + "img/aws.1023339d.jpg";